import { useEffect } from "react";
import { showInfoNotification } from "../../beta/utils/toastrNotifications";
import { getCurrentDate } from "utils/dateUtils";

/**
 * Custom hook to handle password expiration notifications
 * Stores password expiry information in localStorage and displays a toast if needed
 * @param {Object} user - User object containing daysLeftForPasswordExpiration and isAuthenticatedBySso
 */
export const usePasswordExpirationNotification = (user) => {
    useEffect(() => {
        if (
            user !== null &&
            user?.daysLeftForPasswordExpiration !== undefined
        ) {
            // Check if we should show the notification
            if (
                localStorage.getItem("passwordExpirationCheckedOn") !==
                    getCurrentDate() &&
                user.daysLeftForPasswordExpiration > 0 &&
                user.daysLeftForPasswordExpiration <= 14
            ) {
                // Build message based on authentication method
                let expiryPrefixString =
                    "You are logged in via SSO, but we noticed your LiquidMetrix password is due to expire in ";
                if (!user?.isAuthenticatedBySso) {
                    expiryPrefixString = "Your password is due to expire in ";
                }

                // Display notification
                showInfoNotification(
                    `${expiryPrefixString}${Math.ceil(
                        user.daysLeftForPasswordExpiration
                    )} days. Click <a href="app#/settings/user" style="color:white;text-decoration:underline;">here</a> to change now.`,
                    "",
                    15000
                );

                // Mark notification as shown
                localStorage.setItem(
                    "passwordExpirationCheckedOn",
                    getCurrentDate()
                );
            }

            if (
                localStorage.getItem("passwordExpirationCheckedOn") !==
                    getCurrentDate() &&
                user.daysLeftForPasswordExpiration <= 0 &&
                user?.isAuthenticatedBySso
            ) {
                // Build message for SSO users with expired password
                let expiryPrefixString =
                    "You are logged in via SSO, but we noticed your LiquidMetrix password has expired.";
                showInfoNotification(
                    `${expiryPrefixString} Click <a href="app#/settings/user" style="color:white;text-decoration:underline;">here</a> to change now.`,
                    "",
                    15000
                );

                // Mark notification as shown
                localStorage.setItem(
                    "passwordExpirationCheckedOn",
                    getCurrentDate()
                );
            }
        }
    }, [user]);
};
